

export class VehicleDetailsApplicationInput implements IVehicleDetailsApplicationInput {
    /** The auto-generated id of the application module master */
    applicationModuleId!: number;

    constructor(data?: IVehicleDetailsApplicationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationModuleId = _data["applicationModuleId"];
        }
    }

    static fromJS(data: any): VehicleDetailsApplicationInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsApplicationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationModuleId"] = this.applicationModuleId;
        return data; 
    }
}

export interface IVehicleDetailsApplicationInput {
    /** The auto-generated id of the application module master */
    applicationModuleId: number;
}

